/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Not_ConfirmedInputs */

const cs_enum_not_confirmed = /** @type {(inputs: Enum_Not_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepotvrzeno`)
};

const en_enum_not_confirmed = /** @type {(inputs: Enum_Not_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not confirmed`)
};

/**
* | output |
* | --- |
* | "Not confirmed" |
*
* @param {Enum_Not_ConfirmedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_not_confirmed = /** @type {((inputs?: Enum_Not_ConfirmedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Not_ConfirmedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_not_confirmed(inputs)
	return cs_enum_not_confirmed(inputs)
});